import './require-babel-polyfill';
import 'ziggeo-client-sdk/build/ziggeo.css';
import 'ziggeo-client-sdk/build/ziggeo.js';

export ZiggeoPlayer from "./components/ZiggeoPlayer";
export ZiggeoRecorder from "./components/ZiggeoRecorder";


// WEBPACK FOOTER //
// ./src/index.js